import { SourceUrlRow } from '../types';
import { mockDomainTypeShares } from './common';

export const mockSourceUrls: SourceUrlRow[] = [
  { id: 'url_src_1', url: 'https://stockbrokers.com/guides/best-online-brokers', title: 'Best Online Brokers and Trading Platforms', domain: 'stockbrokers.com', domain_type: 'Reference', retrieved: 19.6, retrieval_rate: 0.3, citation_rate: 1.1, mentions: 0, gap_score: 302 },
  { id: 'url_src_2', url: 'https://www.investopedia.com/best-online-brokers-4587872', title: 'Best Online Brokers for Trading', domain: 'investopedia.com', domain_type: 'Editorial', retrieved: 18.3, retrieval_rate: 0.2, citation_rate: 1.0, mentions: 0, gap_score: 174 },
  { id: 'url_src_3', url: 'https://www.bankrate.com/investing/best-online-brokers-for-beginners/', title: 'Best Online Brokers for Beginners', domain: 'bankrate.com', domain_type: 'Reference', retrieved: 17.5, retrieval_rate: 0.2, citation_rate: 1.2, mentions: 0, gap_score: 172 },
  { id: 'url_src_4', url: 'https://www.nerdwallet.com/best/investing/online-brokers-for-stock-trading', title: 'Best Online Brokers for Stock Trading', domain: 'nerdwallet.com', domain_type: 'Corporate', retrieved: 14.2, retrieval_rate: 0.2, citation_rate: 0.9, mentions: 0, gap_score: 137 },
  { id: 'url_src_5', url: 'https://www.reddit.com/r/stocks/comments/trading_tools', title: 'What tools are worth paying for?', domain: 'reddit.com', domain_type: 'UGC', retrieved: 12.9, retrieval_rate: 0.1, citation_rate: 1.5, mentions: 0, gap_score: 195 },
  { id: 'url_src_6', url: 'https://www.youtube.com/watch?v=best-trading-tools', title: 'Trading Tools for Small Accounts', domain: 'youtube.com', domain_type: 'UGC', retrieved: 10.8, retrieval_rate: 0.1, citation_rate: 0.8, mentions: 0, gap_score: 79 },
];

export const mockUrlsData = {
  total: 1243,
  page: 1,
  limit: 50,
  domain_types: mockDomainTypeShares,
  data: [
    {
      id: 'url_1',
      url: 'https://tradingbase.com/',
      domain_id: 'domain_1',
      status_code: 200,
      crawl_status: 'completed',
      last_crawled: '2024-05-27T10:00:00Z',
      word_count: 2450,
      seo_score: 85
    },
    {
      id: 'url_2',
      url: 'https://tradingbase.com/products',
      domain_id: 'domain_1',
      status_code: 200,
      crawl_status: 'completed',
      last_crawled: '2024-05-27T10:05:00Z',
      word_count: 1890,
      seo_score: 78
    },
    {
      id: 'url_3',
      url: 'https://tradingbase.com/pricing',
      domain_id: 'domain_1',
      status_code: 200,
      crawl_status: 'completed',
      last_crawled: '2024-05-27T10:10:00Z',
      word_count: 1240,
      seo_score: 82
    },
    {
      id: 'url_4',
      url: 'https://blog.tradingbase.com/market-analysis',
      domain_id: 'domain_2',
      status_code: 200,
      crawl_status: 'completed',
      last_crawled: '2024-05-27T09:50:00Z',
      word_count: 3200,
      seo_score: 88
    },
    {
      id: 'url_5',
      url: 'https://docs.tradingbase.com/getting-started',
      domain_id: 'domain_3',
      status_code: 200,
      crawl_status: 'completed',
      last_crawled: '2024-05-27T10:02:00Z',
      word_count: 2100,
      seo_score: 90
    }
  ]
};
